module.exports = "/_next/static/images/is-357dcb1c719d20242b4a80110ad5840d.svg";